const RestaurantMenuTabs = {
  CATEGORIES: 'categories',
  UPSELLING_CATEGORIES: 'upselling-categories',
  SUGGESTIONS: 'suggestions',
  PRODUCTS: 'products',
  MENUS: 'menus',
  OPTIONS: 'options',
};

export default RestaurantMenuTabs;
